export default function generateId(prefix) {
  return `${prefix}-${Math.random().toString(36).substring(7) + Date.now()}`
}